// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {

  /* App Config */
  name: 'DEV',
  production: false,
  apiProtocol: 'http',

  /* API Services Config */
  versionroot: 'assets/data/version.json',
  assetsroot: 'https://assets.totaldoc.com',
  apiroot: 'https://surt-dev.totaldoc.io/api',
  localroot: 'http://localhost:9000/api',

  /* Version Config */
  releaseDate: '25/07/2024',
  versionNumber: '1.0.0',
  version: 'a',
  baseurl: '/',

  //signature
  sha1: '2D:40:97:26:A0:FE:35:58:52:63:B6:A5:6F:87:4D:34:F0:BA:E0:B3',
  sha256: '74:C2:85:4F:91:A9:44:C9:4E:3A:4B:E6:F8:47:A3:6A:DB:63:FD:41:8D:E3:9B:35:52:38:3F:7D:A9:78:6F:AC',

  validateCertificateSAT: false,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
